import React, { forwardRef, useEffect, useRef, useState } from "react";
import styles from "./styles";
import { Cogs } from "../../../../models/products";
import { useTranslation } from "react-i18next";

import { Box, Button, Flex, InputGroup, InputLeftAddon, InputLeftElement, InputRightElement, Menu, MenuButton, MenuItem, MenuList, Popover, PopoverTrigger, Tooltip, useDisclosure } from '@chakra-ui/react';

import { useDispatch, useSelector } from "react-redux";
import {customCogsDataSelector, organizationDataLanguageSelector, organizationSelector} from "@store";
import { currencyOptions } from "utils/currency/currencyOptions";
import AddColumnModal from "../add-column-modal/AddColumnModal";
import { deleteCogs, editProducts, productsDataSelector } from "store/products";
import {useCurrencySign} from "../../../../utils/custom-hooks/useCurrencySign";
import {TiArrowSortedDown, TiArrowSortedUp} from "react-icons/ti";
import {AiOutlinePercentage} from "react-icons/ai";
import {BsThreeDotsVertical} from "react-icons/bs";

const productsImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAe1BMVEX///8AAABZWVnj4+PLy8urq6udnZ0vLy/09PT8/Pzv7+/o6Oi9vb23t7fCwsLb29uBgYFJSUkZGRlPT09gYGB6enrT09OWlpaxsbGkpKSHh4fIyMhjY2N5eXlDQ0Nvb28iIiI4ODgrKysQEBAdHR1xcXE0NDSXl5eOjo5hZRS9AAAMaUlEQVR4nO2daXvqKhSFidaaOMWhWoc6t6f+/194JWZHNgHCmNjnZn25t6cR8xYCi82GENKqVatWrVq1atWqVatWrVq1atWqVatWr6XVIdpPkqbvIpzSTpSp0xs2fStB1P2Inup/pk3fj28NfiJO8+Wu6ZvyqMGS53voYz1o+ta8KN6K+TIdfv98e00+FXwPTXd/uX99r+TL9LWOm75TO/VENIt/4vb6/vfa63qOEGb5f9dk2OsIIefTt6bv2USjC7r7W7LJ/69Hf5u8bU/i9jr+I/3rro/uexs/H8keXCOryn9/wA/cDSiraVYtJUKSVeW8jPjyfiCdobvd581OREglq8qX9QPIgEbRsbDZMkIir8pX7F+HRwmfkjD7ZO+jjBhF1+nbK/mBwR63sy77ywpCIu9gv8Yv4gc4A/rBtbBqQirJUzl77yo/Voc4A9opPUF6hLSk3VRUlfPtKsydawob0IXgZrQJqbobYVUeG2uv2IDOhH9sI0Kq3fRSZoxmmwbaKzagZ4m5NCa8qyt8Ki+3etvr6BvxSc2IDSHVbtsXUB5HdbXX3Rn9dSfyK20JiayDXWxqCNphA3oZqa51IKR6E1Vl6PaaLthvm4/VVzsSEllV/gQLMmMDel1XXe9OSDLbI6jKIEFmzoBq3LYXwuyrRQ724nlSyRnQd53PeCMkWVWWx8rrXtkPmIgzoL96n/JJSDVcl6vSz4wyuaFCb7rPuW9CeitvNxy4q+wMdIQN6Fa/HwtAeNcY3U7HvUBsQKcmrSIE4RAHTKLI1eisr2xpS7NWH4CwHFF362tGaNb2YzoEeSdMBcHzo0N5O1Te0XwK45tQvKRlXRw2oB82UzS/hG/C4FwUWa4LpMgPlgMUWvI64pfWlEFTm+K6iG9h6448Eo44LKaDmJuXhg3o2X624o0w5r3MesX8YFoB2IDKAhRa8kW45vg+YvLG/PhpVFg8ZYs6uK3u+SEcojlp9BgBWcKTSWncEvxhO3Jxtl4I+TH+mLlGljAyGKd7aTnL4DS1pvRA2OXG+GveqhDhRru4wX1c2Ih65f7SitKdkB/jt/ALRDgzu6P5QjyynswpXQlX3/gW+s9eExHqTxKhwPcvIaNxXboRJnvu29m4AibUnSQWnyot6rKa6z+XToQT7ntnqD/BhLqTRHgC9/SH6TWSq69H6UAY882IKwMTRnqz8hguz1v7ULwYBLoux1W9tD0hP8Z3+HkuR6gIvDOCyXz/+U/JbhqpdNorc2FsCQeiMV5J+KNV7jm/mhtduhv++7Dme2ldWhLyY/yPoA1yhFqTxBQuLgc+kslS9VRG0fdSWJdWhN0zLnsudP48oc70ANrjl/jX6bu6KmmL5evShvDGFXsTX8YT6kwS4Vq52Y5HP+qqpC2WrUtzwhW3nH+WzYyAcJbbk2t12TDFrJhPpr84vausy7MujQn5fk2+dgCER5jLVk8SoQ1WT7bi8bGiKulIMjAn3HGlLBSjERB+gTGovO8hFKs3E1l9ipNi2bpcjuCZ0iJMjlwBSisGhB14us5V5cOsaaEFSDUYy9xrSTqEY+4zX+pY9pMQbElV1UDBZhHkty3n/sWqNsYD3j5VmZQnIdifikli8Qjo0+WSZVKy2leZ2A33gWWlz3wSgtmsmCRCg7OKPSY7cSYlo4MqiWLIdc8njeH7SVj0kco/4wAKt04+kuRsMTrLMvF4kyYZ47EYQvDTyrQJaCWVHZJKyWRaUZX93zJkyqUhnPX+yAwhVM+H6npYIXcO3VbZ9NIeNj4QoxtUYggJzNYVlxcBZB9pKslkr67K662AXHFXLrRjJCwhNFNF/wsBEZelOKT0Xe3tTo/EUT4QU5GAxIolhGYqnyQm8A0+86mSKpu+5cf4o0kLYgnJOf9BejWMmSc3prLS33Okq6vZdgtECB2ltIagRWllARnqbtO1AE0HYkQIpnorubgL3xJqO0e1Tb8Yr1AiQnLOf5JcfEMXh5Happstj2XChGAaJH8o+B69iJy9VjdR5i8f6tUUJoRmKP5TFbFlh5vX1XBdrkq7tC1MCJZF7MnAT2rZQQ/icgwtnTBHCNNbUXNwN93mmnonhFCoyPTBQ3qwvl9z/fNOSPIYnWiSCJN0A8fkqkHknxAGhHLsw6vp1tTIIyHElaCZlisKHMfS/oaNtfdIGM33j40meVssRez5FbVaFPkkzPqQz1XRm/JtEaZWF+fb1lfXO2FGmf+X9y3Qq+nna7gLJx37IgTt8XWKFbVwwrbGNyFnzSpW1MII35B3QjxJhH+t83CKFN+Qd0I0SYSBSWPxzZ+48Kh3whN7mf6Kmkdx4UZXT9N951N/mBINV9Q8SX4/JmJdWzKZsgtEzJYl8xU1D+Kblydfysw8mUkihGO97f/SEZ+J4ImQapWvwA/5i+qY3D8F3uPin/CumG6SLuwLVKssBhdEYIT/fQUhpBrA2NeI6S6iQtNjMMJCECjWT7D1IXBRk3B1WAhCe51aTyuAbr3YQRGOkDVP9R0xCkPwqQjxhSPkVrY+6jkCD9abtuEJk6ikOo4Qgf5lF56QT8J9yPcW95Lgi+LwhGNZqnrQc/4ggDEjNTyHJB4LT9qiCnZOCoxQn7UQEprqw6+kF+r0QqwmAtaqLkIq2ZqXIsXHWkX3RuokJDQJRpY5cfJ72NaKua1aCe8aCE6cyLX3dyLub14kNf91E5Is00cG6esEPOi/6ZDUACGV6Cyxh3yc0ASPYRb4aohQ1ulkcrYDkMSapV41TCjLpPx2sgOQpZet3DdMSJKRNNHH3g7AIknW3psmzAqR7uqyswPF0m/20ysQ3pV+niWQFnYAIuyPBK8XISR0F6LMo5ueDQeD0SN4+TqEhHp0acrWcaL/UMJnHi38pQgJ9eiS1zncv0PzAGcIYOQh6VcjpFrdZIZA60BcWPrNc69ekfCurjS7+VT5UEJLz0dUR0Iw8abL81WEhHp0mR24qk9Vh8tyH+9ICB83dSAahCRL4ZZARl9SOwDRS1jociJMiqZk6j70CKlW0hetLMR2AJZ+IdXahTAu/LNxwF6fkKi2k/YFr5KBpV/4jQPh8PlNxsmpRoRE9VB+b7knJOKKtidko/XGk3NTQkInztKH8oexA9C7F5uTrAnZvbTmuwssCKlW0t15hR0obZi1JWRD2d+GnyXWhES1eeSQ2QF4ZAsgS0KUq2IRJrMnvGvQk+1b+75BI31m7tgRogmdTTKeEyGhZxJU7H5+br6yIkTTcquUWFdCqt1SsTnvmcJrQ4jaiF0ung/Cu9Kb+L1HbG6SOWGC9hZZ7Vj2RkhkE+fT8wJjwgFqGrYJsf4IidAOMH94U0KcWWy9g8krISnbAebGDAlXqBz7wK1vQirWDjAzATNCtIHh22HhLwQhedoBdl+OESE6c2HmslK0D0NIcjvA5rGaEKJsP7eMbfhbBXkFWjxmHx8DQrQm5rjF7jkx2Yd+z5s+IeqRnc9EYHNtf4JC6hImaFx1vyXuJZs/4d6IqkkYo3HeR2JByW4dA20P1iMcsqcW9L2kh6Q8YQYZoCa1CNE47ysdXfgy2Og48g2pQ4gO+NwrLjSTGNE7pAYhyr3zuSdEvh3lyyNkNeEv+9V+N/Emitcye4OsJEQBC/95zGvF+TIfXrJrqgjZcMg1yKaegTQVLIN0rskKQnac7wdLXx705OclRx3HmlQSxmxij/KEK2epIV1yw1WEKGARfpe5PAwaSReaNKQgRK6jnh3Kypqc2UHKCdFoVd+uM+81KSVEB2TV+4LnWAV5MIWUEbIBi1OtWz8zKWtytjGBlBCyAYtDMy+vjteqmtTPQhUTsgsTtW6hx1LW5EGzJoWEbMCi1m2RZSlr8qxTkwLC5MwU4vd9e1ZSN9f3Ksgy4YCNL4QOhGlKse2G5mcqIUuEaGGi+deqF7KG5AnZgMUp1Ol/lopHSkhJdXCEbMBi0cwooVSiqsm+EBITsgELb6eoelaiWsIX1CQiZN8yVeshHYZSQl44SJaQDVh4eTdsQCkh/7FHQTOErJGp86Qca6kgT58A+TwOnx1W67fadlLWZP8BCYQpEw76V+dxVa5SbLqhNZkSQecb8ojYIEomqposbyKr89g/b0omeuckU4U4p7keaULWegyQb+nUZK3HjwSRGnL+V0YJpRTp0ucXtNqWEkM2GJAJoGRXgqzrEOoahSAPf7+PEWq1yTzNaVtvULtmxX/JhbZq1apVq1atWrVq1apVq1atWrVq9T/Vf8ciiyyCaWbYAAAAAElFTkSuQmCC`;


export const calculateProductTotalCost = (sellingPrice: number, fob: number, cogs: Cogs[]) => {
    if (!fob)
        fob = 0;
    let total = fob;
    cogs?.forEach((cog) => {
        if (!cog || !cog.value)
            return;
        let { isPercentage, fromFob, value } = cog;

        if (isPercentage) {
            if (fromFob)
                total += (fob * (value / 100));
            else
                total += (sellingPrice * (value / 100));
        } else {
            total += value;
        }
    });
    if(isNaN(total)){
        return 0
    }
    return total
};

const dateFormat = (date: Date) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return (date.getDate()) + " " +
        monthNames[date.getMonth()] + " " +
        date.getFullYear().toString().slice(2, 5);
};

enum SortStage {
    DESC,
    ASC,
    NONE
}

export namespace cogsCells {


    export const HeaderCell = ({ header, editable, editBulk, isPercentage, fromFob, setUpdate, setApplyFlag, rowData, setPage, displayEdit, setSelectedSort, selectedSort }:
   { header?: string, editable?: boolean, editBulk?: any, isPercentage?: boolean, fromFob?: boolean, setUpdate?: any
       , setApplyFlag?: any, rowData?: any; setPage?: any; displayEdit?: boolean, setSelectedSort: any, selectedSort: any}) => {
        const [showMenu, setShowMenu] = useState(false);
        const { t } = useTranslation(['translation', 'translation']);
        const [inputValue, setInputValue] = useState(0);
        const { onOpen, onClose, isOpen } = useDisclosure();

        const organization = useSelector(organizationSelector);
        const dataLanguage = useSelector(organizationDataLanguageSelector);
        const products = useSelector(productsDataSelector);
        const dispatch = useDispatch();
        const allCogs = useSelector(customCogsDataSelector);

        const mouseEnter = () => {
            setShowMenu(true);
        };
        const mouseLeave = () => {
            setShowMenu(false);
        };


        const addNewColumn = (newCog: Cogs) => {

        };

        const deleteCog = (name?: string) => {
            const foundCog = allCogs?.find((item) => item?.name?.toLowerCase() === name?.toLowerCase());
            setPage(0);
            !!organization?.id && !!foundCog?._id && !!dataLanguage?.id &&  dispatch(deleteCogs({ organizationId: organization?.id, cogsName: foundCog?._id, dataLanguageId: dataLanguage?.id }));

        };

        let isDate = false, isProduct = false;
        const newHeader = !!header ? t(header, { ns: 'translation' }) : "";

        if (header === 'LAST_UPDATE')
            isDate = true;
        if (header === 'PRODUCT')
            isProduct = true;

        const handleSortKeyClick = (header?: string) => {
            setSelectedSort((prevState:any) => {
                if(prevState?.key === header){
                    if(prevState?.stage === -1){
                        return {key: header, stage: 1}
                    }
                    else if (prevState?.stage === 1){
                        return {key: header, stage: 3}
                    }
                    else {
                        return {key: header, stage: -1}
                    }
                }else{
                    return {key: header, stage: -1}
                }
            })
        }

        const customToolTip = (header: string, fromFob?: boolean) => {
            return (
                <Flex padding={2} alignItems="center" height={"100%"}>
                    <Box >
                        <AiOutlinePercentage size={32} color="#EDE5FC" />
                    </Box>
                    <Box width={7} />
                    <Flex flexDirection={"column"}>
                        <styles.ToolTip >
                            {header}
                        </styles.ToolTip>
                        <styles.ToolTipSubtext >
                            From '{fromFob ? "FOB" : "Selling Price"}'
                        </styles.ToolTipSubtext>
                    </Flex>
                </Flex>
            );
        };


        return (

            <styles.CogsTh onClick={() => handleSortKeyClick(header)} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave} isDate={isDate} isProduct={isProduct}>
                <AddColumnModal setApplyFlag={setApplyFlag}
                                setUpdate={setUpdate} editModal={true} isOpen={isOpen} onClose={onClose}
                                data={rowData} onApply={addNewColumn} isPercentage={isPercentage} name={header} fromFob={fromFob} />
                {editable ?
                    <>
                        {/* <Popover
                                isOpen={isOpen}
                                onOpen={onOpen}
                                onClose={onClose}
                                placement="bottom"
                                closeOnBlur={true}
                            >
                                <PopoverTrigger>
                                    <styles.EditBulkButton>{t("EDIT_BULK", { ns: 'translation' })}</styles.EditBulkButton>
                                </PopoverTrigger>
                                <styles.EditBulkPopoverWrapper _focus={{ boxShadow: null }}>
                                    <InputGroup>
                                        <styles.EditBulkInput
                                            type={"number"}
                                            value={inputValue ? inputValue : 0}
                                            onChange={(e) => setInputValue(e.target.valueAsNumber)} />
                                        <InputRightElement children={
                                            <styles.EditBulkApplyButton onClick={() => editBulk(header, inputValue)}>
                                                <BsCheckLg color={"#c9c9c9"} size={"1rem"} />
                                            </styles.EditBulkApplyButton>
                                        } />
                                    </InputGroup>
                                </styles.EditBulkPopoverWrapper>
                            </Popover> */}
                    </>
                    //
                    :
                     editable === false ?
                        // all editable headers without fob
                        <Flex marginLeft={5} alignItems={"center"} justifyContent="center">
                            <Tooltip backgroundColor={"white"} borderRadius={10} boxShadow={"0px 23px 76px #00000012"} placement="top" label={isPercentage ? customToolTip(newHeader, fromFob) : null}>
                                <Flex  alignItems={'center'} gap={2}>
                                    {!!newHeader ? t(newHeader, { ns: 'translation' }) : ""}
                                    {newHeader === 'FOB' && selectedSort?.key === newHeader ? selectedSort.stage === 3 ? <></> : selectedSort.stage === -1 ? <TiArrowSortedDown/> :
                                        selectedSort.stage === 1 ? <TiArrowSortedUp/> : '' : ''}
                                </Flex>
                            </Tooltip>
                            <Box width={1.5} />
                            <Box justifySelf={"flex-end"} opacity="0" display={showMenu && displayEdit ? "none" : "block"}>
                                <BsThreeDotsVertical />
                            </Box>
                            <Menu boundary={"scrollParent"} placement="left">
                                <MenuButton >
                                    <styles.StyledBox show={showMenu && displayEdit}   >
                                        <BsThreeDotsVertical />
                                    </styles.StyledBox>
                                </MenuButton>
                                <MenuList>
                                    <MenuItem onClick={() => { onOpen(); }}>Edit</MenuItem>
                                    <MenuItem onClick={() => { deleteCog(header); }}>Delete</MenuItem>
                                </MenuList>
                            </Menu>

                        </Flex>

                        :
                        <Tooltip label={null}>
                            <Flex  alignItems={'center'} gap={2}>
                                {!!header ? t(header, { ns: 'translation' }) : ""}
                                {selectedSort?.key === header ? selectedSort.stage === 3 ? <></> : selectedSort.stage === -1 ? <TiArrowSortedDown/> :
                                    selectedSort.stage === 1 ? <TiArrowSortedUp/> : '' : ''}
                            </Flex>
                        </Tooltip>

                    // <styles.EditBulkGhost>{t("EDIT_BULK", { ns: 'translation' })}</styles.EditBulkGhost>
                }

            </styles.CogsTh>

        );
    };


    export const HeaderTotalCell = ({ header }: { header: string; }) => {
        const { t } = useTranslation(['translation', 'translation']);
        return (
            <styles.CogsThTotalWraper >
                {/*<styles.EditBulkGhost>{"Edit Bulk"}</styles.EditBulkGhost>*/}
                <styles.CogsThTotal>
                    {t(header, { ns: 'translation' })}
                </styles.CogsThTotal>
            </styles.CogsThTotalWraper>
        );
    };

    export const FobCell = ({ value: initialValue, row: { index }, column: { id }, updateCell }: any) => {
        const organization = useSelector(organizationSelector);
        const dataLanguage = useSelector(organizationDataLanguageSelector);
        const currentCurrency = useCurrencySign();

        const [value, setValue] = useState(initialValue);
        const onChange = (e: any) => setValue(e.target.valueAsNumber);
        const onBlur = () => updateCell(index, id, value);
        const input = useRef<any>(null);

        const handleFocus = () =>{
            input.current.blur(); // removing focus
        }
        useEffect(() => setValue(initialValue), [initialValue]);
        return (
            //
            <styles.CogsTdDiv >
                <InputGroup onKeyUp={(e) => {
                    if(e.code === "Enter"){
                        onBlur();
                        handleFocus()
                    }
                }} width={"80%"} display="flex" justifyContent={"center"}>
                    <InputLeftElement zIndex={0} pointerEvents='none' color='gray.400' children={currentCurrency} />
                    <styles.TableInput ref={input} type={"number"} value={value ? value : 0} onChange={onChange} onBlur={onBlur} onWheel={(e:any) => e?.target?.blur()} />
                </InputGroup>

            </styles.CogsTdDiv>
        );
    };

    export const CogsCell = ({ value: initialValue, row, column: { id }, updateCell }: any) => {
        const [cogs, setCogs] = useState(initialValue);
        const organization = useSelector(organizationSelector);
        const dataLanguage = useSelector(organizationDataLanguageSelector);
        const currentCurrency = useCurrencySign();

        const onChange = (newValue: number) => {
            /*   if (newValue === initialValue) {
                  return;
              } */
            setCogs({
                name: cogs?.name,
                isPercentage: cogs?.isPercentage,
                fromFob: cogs?.fromFob,
                value: newValue
            });
        };
        useEffect(() => {
            setCogs(initialValue);
        }, [initialValue, row]);
        const onBlur = () => {
            updateCell(row?.index, id, cogs);
        };
        const input = useRef<any>(null);

        const handleFocus = () =>{
            input.current.blur(); // removing focus
        }
        return (
            <styles.CogsTdDiv >
                <InputGroup onKeyUp={(e) => {
                    if(e.code === "Enter"){
                        onBlur();
                        handleFocus()
                    }
                }} width={"80%"} display="flex" justifyContent={"center"}>
                    <InputLeftElement zIndex={0} pointerEvents='none' color='gray.400' children={cogs?.isPercentage ? "%" : currentCurrency} />
                    {/* <InputLeftAddon children={cogs.isPercentage ? "%" : currentCurrency} /> */}
                    <styles.TableInput
                        ref={input}
                        type={"number"}
                        value={cogs?.value ? parseFloat(cogs?.value?.toFixed(2)) : 0}
                        onChange={(e: { target: { valueAsNumber: number; }; }) => onChange(e?.target?.valueAsNumber)}
                        onBlur={onBlur} />
                </InputGroup>

            </styles.CogsTdDiv>
        );
    };

    export const ProductOverViewCell = ({ value: initialValue }: any) => {
      return (
        <styles.ProductWrapper>
          <styles.ProductImage
              onError={(event: any) => {
                  const imgElement = event.target as HTMLImageElement;
                  imgElement.src = productsImage;
              }}
            src={
              !!initialValue?.imageUrl ? initialValue?.imageUrl : productsImage
            }
          />
          <styles.ProductIndicator mode={"activate"} />
          <styles.ProductInfo>
            <styles.ProductName>
              <Tooltip label={initialValue?.name}>
                {!!initialValue?.name
                  ? initialValue?.name?.length < 50
                    ? initialValue?.name
                    : initialValue?.name?.slice(0, 50)
                  : ""}
              </Tooltip>
            </styles.ProductName>
            <styles.ProductSKU>{"SKU " + initialValue?.sku}</styles.ProductSKU>
            <styles.ProductSKU>
              {!!initialValue?.asin && "ASIN " + initialValue?.asin}
            </styles.ProductSKU>
          </styles.ProductInfo>
        </styles.ProductWrapper>
      );
    };

    export const DefaultView = ({ value: initialValue }: any) => {
        if(typeof initialValue === 'number'){
            initialValue = initialValue?.toLocaleString("en-US", {maximumFractionDigits: 2})
        }
      return (<styles.CogsTdDiv>{initialValue}</styles.CogsTdDiv>);
    };

    export const LastUpdateView = ({ value: initialValue }: any) => {
        return (
            <styles.CogsTdDiv isLastUpdate={true} bgc={'rgb(242, 244, 246)'}>
                {!!initialValue ? dateFormat(new Date(initialValue)) : ''}
            </styles.CogsTdDiv>
        )
    };

    export const TotalCostView = ({ value: initialValue, rows, row }: any) => {
        const organization = useSelector(organizationSelector);
        const dataLanguage = useSelector(organizationDataLanguageSelector);

        const currentCurrency = useCurrencySign();

        const { sellingPrice, fob } = rows[row.id].values;
        const cogs = initialValue.map((key: string) => rows[row.id].values[key]);
        return (
            <styles.CogsTdTotal>

                {currentCurrency + calculateProductTotalCost(sellingPrice, fob, cogs)?.toLocaleString('en-US', {
                    maximumFractionDigits: 2
                })}
            </styles.CogsTdTotal>
        );
    };

    export const AddColumn = ({ header, onClick }: { header: string, onClick: () => void; }) => {
        const { t } = useTranslation(['translation', 'translation']);
        return (
            <styles.CogsTh >
                {/*<styles.EditBulkGhost/>*/}
                <styles.AddColumnButton onClick={() => onClick()}>
                    {"+ " + t(header, { ns: 'translation' })}
                </styles.AddColumnButton>
            </styles.CogsTh>
        );
    };

    export const IndeterminateCheckbox = forwardRef(
        ({ indeterminate, isHeader, ...rest }: any, ref) => {
            const defaultRef = useRef();
            const resolvedRef = ref || defaultRef as any;
            /*   useEffect(() => {
                  resolvedRef.current.indeterminate = indeterminate;
              }, [resolvedRef, indeterminate]); */
            return null;
            return (
                <styles.CheckBoxWrapper>
                    {/*{isHeader && <styles.EditBulkGhost/>}*/}
                    <styles.CheckBoxInput type="checkbox" ref={resolvedRef} {...rest} />
                    {/*{isHeader && <styles.EditBulkGhost/>}*/}
                </styles.CheckBoxWrapper>
            );
        }
    );
}

export default cogsCells;
